import moment from 'moment';
import { TOKEN_KEY } from '@/common/constant';
import { getLocalStorageValue } from '@/common/utils';

const getToken = () => {
  let token = null;
  try {
    const tokenStr = getLocalStorageValue(TOKEN_KEY) || {};
    token = JSON.parse(tokenStr);
  } catch {
    // token = {};
  }
  return token;
};

/**
 * Verify token
 * @returns
 */
const verifyToken = () => {
  let isExpired = false;
  let token = null;
  try {
    token = getToken();
    if (token && Object.values(token).length) {
      const { expires_date, expires_in } = JSON.parse(token);
      const expiredTime = expires_date + expires_in;
      const curTime = moment().valueOf() + 30;
      // console.log(
      //   'verifyExpiredToken - curTime :',
      //   moment(curTime).format('YYYY-MM-DD h:mm:ss'),
      //   ', expiredTime : ',
      //   moment(expiredTime).format('YYYY-MM-DD h:mm:ss')
      // );
      if (curTime > expiredTime) {
        isExpired = true;
      }
    }
  } catch (err) {
    // console.log('🚀 verifyExpiredToken ERROR : ', err);
  }
  return {
    token,
    isExpired,
  };
};

export { verifyToken, getToken };
